import { DEFAULT_DELIVERY_AGENT_ORDER_SOURCE, isRestaurantStoreOrderSource } from './menuChannels';
import { canEditRestaurantStoreProfile as canEditProfileByPermission } from './rbacSession';

export function isEmployeeDeliveryAgent() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const role = user?.userRole || user?.role;
    return String(role || '').toUpperCase() === 'DELIVERY_AGENT';
  } catch {
    return false;
  }
}

/** Profile edit: fn.profile_edit (or *). Delivery agents never edit. */
export function canEditRestaurantStoreProfile() {
  if (isEmployeeDeliveryAgent()) return false;
  return canEditProfileByPermission();
}

/** Map navigation / store channel keys to delivery-agent order source. */
export function resolveDeliveryAgentOrderSourceFromState(locationState, orderDetails) {
  const fromState = locationState?.orderSource ?? locationState?.deliveryOrderSource;
  if (fromState) return String(fromState).toUpperCase();

  const fromOrderType = locationState?.fromOrderType;
  if (fromOrderType === 'restaurant') return 'RESTAURANT';
  if (fromOrderType === 'myeats') return 'MYEATS';
  if (fromOrderType === 'jreats') return 'JREATS';

  const orderSource = String(
    orderDetails?.orderSource ??
      orderDetails?.order_source ??
      orderDetails?.Order_Source ??
      ''
  )
    .trim()
    .toUpperCase();
  if (isRestaurantStoreOrderSource(orderSource)) return 'RESTAURANT';
  if (orderSource === 'JREATS') return 'JREATS';
  if (orderSource === 'MYEATS') return 'MYEATS';

  return DEFAULT_DELIVERY_AGENT_ORDER_SOURCE;
}
